import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";

const LOGO = "/logo-header.png";

export const Header = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();
  const nav = [
    { to: "/", label: "Home" },
    { to: "/prodotti", label: "Tutti i piatti" },
    { to: "/prodotti?cat=Primi Piatti Pronti", label: "Primi" },
    { to: "/prodotti?cat=Secondi Piatti Pronti", label: "Secondi" },
    { to: "/prodotti?cat=Contorni", label: "Contorni" },
    { to: "/prodotti?cat=Dolci", label: "Dolci" },
    { to: "/prodotti?cat=Gluten Fit", label: "Gluten Fit" },
    { to: "/b2b", label: "B2B" },
  ];
  return (
    <header className="sticky top-0 z-50 bg-[#FDFBF7] border-b border-[#E7E0D8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center group shrink-0">
          <img src={LOGO} alt="Piatti Pronti Gluten Free" className="h-12 sm:h-14 w-auto transition-transform duration-300 group-hover:scale-[1.03]" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((n) => (
            <Link
              key={n.label}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`link-underline text-sm font-medium ${pathname === n.to.split("?")[0] && !n.to.includes("?") ? "text-[#2E8A57]" : "text-[#44403C]"} hover:text-[#2E8A57] transition-colors`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <button
          data-testid="cart-open-btn"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-2 rounded-full border border-[#1C1917] px-5 py-2.5 text-sm font-semibold hover:bg-[#1C1917] hover:text-[#FDFBF7] transition-colors duration-300"
        >
          <ShoppingBag className="w-4 h-4" />
          <span className="hidden sm:inline">Carrello</span>
          {count > 0 && (
            <span data-testid="cart-count-badge" className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#2E8A57] text-[#FDFBF7] text-xs font-bold flex items-center justify-center">
              {count}
            </span>
          )}
        </button>
      </div>
    </header>
  );
};
